import React, { useState } from 'react';
import {
    ConfigurationImagesType,
    SingleVehicleType,
} from '../../Components/Types';
import Amenities from './Amenities';
import Dimensions from './Dimensions';
import { useMediaQuery } from 'react-responsive';
import {
    ButtonContainer,
    ConfigurationContainer,
    Container,
    Content,
    MobileTab,
    MotorohomeImg,
    TabButton,
} from './InformationTableComponents';

type InformationTableProps = {
    vehicle: SingleVehicleType;
    imagesList: ConfigurationImagesType[];
};
type TabsType = {
    name: string;
    visible: boolean;
};

function InformationTable({ vehicle, imagesList }: InformationTableProps) {
    const tabletView = useMediaQuery({
        query: '(max-width: 1100px)',
    });

    const [tabs, setTabs] = useState<TabsType[]>([
        { name: 'Configuration', visible: true },
        { name: 'Vehicle Details', visible: false },
        { name: 'Amenities', visible: false },
    ]);

    const openTab = (tabName: string) => {
        const tabsList: TabsType[] = [...tabs];
        tabsList.forEach((tab) => {
            if (tab.name === tabName) {
                tab.visible = true;
            } else {
                tab.visible = false;
            }
        });
        setTabs(tabsList);
    };

    return (
        <Container>
            {!tabletView && (
                <ButtonContainer>
                    {tabs.map((tab, index) => {
                        return (
                            <TabButton
                                key={index}
                                $selected={tab.visible}
                                onClick={() => openTab(tab.name)}
                            >
                                {tab.name}
                            </TabButton>
                        );
                    })}
                </ButtonContainer>
            )}

            {(tabs[0].visible || tabletView) && (
                <Content>
                    <ConfigurationContainer>
                        {tabletView && <MobileTab>Configuration</MobileTab>}
                        {imagesList?.map((image: ConfigurationImagesType) => {
                            return (
                                <MotorohomeImg
                                    key={image.url}
                                    src={image.url}
                                    alt={image.alt}
                                />
                            );
                        })}
                        <div />
                    </ConfigurationContainer>
                </Content>
            )}

            {(tabs[1].visible || tabletView) && (
                <Content>
                    {tabletView && <MobileTab>Vehicle Details</MobileTab>}
                    <Dimensions vehicle={vehicle} />
                </Content>
            )}

            {(tabs[2].visible || tabletView) && (
                <Content>
                    {tabletView && <MobileTab>Amenities</MobileTab>}
                    <Amenities amenities={vehicle.amenities} />
                </Content>
            )}
        </Container>
    );
}
export default InformationTable;
